export default __webpack_public_path__ + "static/media/Background_00172.dc6ddd1c.png";